import { AgGridReact } from 'ag-grid-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { reduce, keys, delay, filter, values, each, map, uniq, find, first } from 'lodash';
import Toggle from 'react-bootstrap-toggle';
import {
  Popover, OverlayTrigger,
  FormGroup, Button, Tooltip,
  Dropdown, MenuItem,
} from 'react-bootstrap';
import CustomHeader from '../../../../components/god-table/header';
import SearchField from '../../../../components/search-field';
import { fetchTVProductMappings, updateTVProductMappings } from '../../SetupActions';
import {
  getTVProductMappings, getTVProductRefs, getTVUseProductMappings,
  getTVRequireProducts,
} from '../../SetupReducer';
import ProgressBar from '../../../../components/progress-bar';
import { getViewableDimensions } from '../../../App/AppReducer';
import styles from './styles.css';
import UnifyMappingTable from './UnifyMappingTable';
import ProgramType from '../../../../components/program-type';
import FieldLabelCellRenderer from '../../components/cells/FieldLabelCellRenderer';



function ProgramCellRenderer({ displayName }) {
  return (
    <strong className="text-uppercase"><ProgramType type={displayName} />{displayName}</strong>
  );
}
ProgramCellRenderer.propTypes = {
  displayName: PropTypes.string,
};
ProgramCellRenderer.defaultProps = {
  displayName: null,
};

function GroupRowInnerRenderer(props) {
  const { context } = props;
  const fields = [];
  if (context.allFields && context.allFields.length > 0) {
    const total = context.allFields.length;

    const types = uniq(map(context.allFields, 'object_type'));
    const hasMultiple = types.length > 1;

    each(context.allFields, (field, i) => {
      const obj = hasMultiple ? (<span><code>{field.object_type}</code> <Fa name="chevron-right" /></span>) : null;
      fields.push(
        (<nobr key={field._id}>{obj} <code>{field.name}</code></nobr>),
      );
      if (i < total - 1) {
        fields.push(
          (<span key={`${field._id}-comma`}>, </span>),
        );
      }
    });
  }
  
  let label = 'Products';
  if (props.value === 'mapping') {
    label = 'Product Filter Groups';
  } else if (props.value === 'product') {
    label = (<span>CRM <code>Product2</code></span>);
  } else if (props.value === 'inline-product') {
    label = (<span>TruSales Products: {fields}</span>);
  }
  return (
    <strong className="text-uppercase">{label}</strong>
  );
}
GroupRowInnerRenderer.propTypes = {
  value: PropTypes.string,
  context: PropTypes.shape({
    allFields: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};
GroupRowInnerRenderer.defaultProps = {
  value: null,
};

function LabelCellRenderer(params) {
  const { value, data } = params;
  if (!data) {
    return null;
  }
  const { description } = data;
  const hasDescription = description !== null && description !== undefined && description.length > 0;

  let comp = (<span>{value}</span>);
  
  if (hasDescription) {
    const popover = (
      <Popover id={`row-${data.id}`} className={styles.dropdownPopover}>
        <div style={{ padding: 10 }}>{description}</div>
      </Popover>
    );
    comp = (
      <span>
        {comp}&nbsp;
        <OverlayTrigger
          trigger="hover"
          placement="top"
          overlay={popover}
        >
          <Fa name="info-circle" className="text-active" style={{ cursor: 'pointer' }} />
        </OverlayTrigger>
      </span>
    );
  }
  return comp;
}
LabelCellRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    type: PropTypes.string,
  }),
};
LabelCellRenderer.defaultProps = {
  value: null,
};

function ProductCellRenderer(params) {
  const { value, valueFormatted } = params;
  const cls = value !== null && value !== undefined ? 'text-active' : 'text-muted';
  return (<span className={`${cls} ${styles.productCell}`}>{value ? valueFormatted : '[Excluded]'}</span>);
}
ProductCellRenderer.propTypes = {
};
ProductCellRenderer.defaultProps = {
};

class MappingTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loaded: false,
      tvUseProductMappings: false,
      tvRequireProducts: false,
      tvAllowMultipleProducts: false,
      togglling: false,
      requireTogglling: false,
      allowMultipleProductsTogglling: false,
      allFields: [],
      selectedStatus: 'ALL',
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.valueSetter = this.valueSetter.bind(this);
    this.onToggleUnify = this.onToggleUnify.bind(this);
    this.onToggleRequire = this.onToggleRequire.bind(this);
    this.onToggleAllowMultiple = this.onToggleAllowMultiple.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.processCellCallback = this.processCellCallback.bind(this);
    this.columnCellRendererSelector = this.columnCellRendererSelector.bind(this);
    this.columnValueGetter = this.columnValueGetter.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.fetchData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onToggleUnify() {
    if (!this.state.togglling) {
      this.setState({ togglling: true }, () => {
        const { programs } = this.props;
        const firstProgram = values(programs)[0];
        if (firstProgram && firstProgram[0]) {
          const submitParams = {
            client_id: firstProgram[0].client_id,
            program_id: firstProgram[0].program_id,
            tru_voice_use_product_mappings: !this.state.tvUseProductMappings,
            tru_voice_require_products: this.state.tvRequireProducts,
            tru_voice_allow_multiple_products: this.state.tvAllowMultipleProducts,
            mappings: [],
          };
          this.props.dispatch(updateTVProductMappings(submitParams))
            .then(
              () => {
                this.setState({ togglling: false, tvUseProductMappings: !this.state.tvUseProductMappings });
              },
              () => {
                this.setState({ togglling: false });
              },
            );
        } else {
          this.setState({ togglling: false });
        }
      });
    }
  }

  onToggleRequire() {
    if (!this.state.requireTogglling) {
      this.setState({ requireTogglling: true }, () => {
        const { programs } = this.props;
        const firstProgram = values(programs)[0];
        if (firstProgram && firstProgram[0]) {
          const submitParams = {
            client_id: firstProgram[0].client_id,
            program_id: firstProgram[0].program_id,
            tru_voice_use_product_mappings: this.state.tvUseProductMappings,
            tru_voice_require_products: !this.state.tvRequireProducts,
            tru_voice_allow_multiple_products: this.state.tvAllowMultipleProducts,
            mappings: [],
          };
          this.props.dispatch(updateTVProductMappings(submitParams))
            .then(
              () => {
                this.setState({ requireTogglling: false, tvRequireProducts: !this.state.tvRequireProducts });
              },
              () => {
                this.setState({ requireTogglling: false });
              },
            );
        } else {
          this.setState({ requireTogglling: false });
        }
      });
    }
  }

  applyStatusFilter(value) {
    if (this.gridApi) {
      this.setState({ selectedStatus: value }, () => {
        /*
        const columnFilter = this.gridApi.getFilterInstance('STATUS');
        if (columnFilter) {
          if (value !== 'ALL') {
            columnFilter.selectNothing();
            // columnFilter.selectValue(value);
            console.log('set to', value)

            columnFilter.setModel({
              filterType: 'text',
              // type: 'startsWith',
              filter: value,
            });

          } else {
            columnFilter.selectEverything();
          }
          this.gridApi.onFilterChanged();
        }
        */
      });
    }
  }


  columnCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    const { data } = params;

    return {
      params: {
        showStatus: data?.type === 'product' || data?.type === 'inline-product',
        // showStatus: data?.type === 'product',
      },
      component: FieldLabelCellRenderer,
    };
  }

  onToggleAllowMultiple() {
    if (!this.state.allowMultipleProductsTogglling) {
      this.setState({ allowMultipleProductsTogglling: true, selectedStatus: 'ALL' }, () => {
        const { programs } = this.props;
        const firstProgram = values(programs)[0];
        if (firstProgram && firstProgram[0]) {
          const submitParams = {
            client_id: firstProgram[0].client_id,
            program_id: firstProgram[0].program_id,
            tru_voice_use_product_mappings: this.state.tvUseProductMappings,
            tru_voice_require_products: this.state.tvRequireProducts,
            tru_voice_allow_multiple_products: !this.state.tvAllowMultipleProducts,
            mappings: [],
          };
          this.props.dispatch(updateTVProductMappings(submitParams))
            .then(
              () => {
                this.setState({ allowMultipleProductsTogglling: false, tvAllowMultipleProducts: !this.state.tvAllowMultipleProducts });
              },
              () => {
                this.setState({ allowMultipleProductsTogglling: false });
              },
            );
        } else {
          this.setState({ allowMultipleProductsTogglling: false });
        }
      });
    }
  }


  processCellCallback(params) {
    if (params.column?.colId === 'LABEL') {
      let label = params.value;
      if (params.value === ' -> mapping') {
        label = 'Product Filter Groups';
      } else if (params.value === ' -> product') {
        label = 'CRM Product2';
      } else if (params.value === ' -> inline-product') {
        const fields = [];
        each(params.context?.allFields || [], (grouped) => {
          const fs = [];
          fs.push(grouped.object_label);
          fs.push(grouped.name);
          fields.push(`${fs.join(' > ')}`);
        });

        label = `TruSales Products: ${fields.join(', ')}`;
      }

      return label;
    }
    if (params.column?.colDef?.cellRendererParams?.refData && params.column.colDef.cellRendererParams.refData[params.value]) {
      return params.column.colDef.cellRendererParams.refData[params.value];
    }
    return params.value;
  }

  handleDownload() {
    if (this.gridApi) {
      const params = {
        columnGroups: true,
        fileName: `TruVoice Product Mappings - TruSales`,
        sheetName: `TruVoice Product Mappings`,
        exportMode: 'xlsx',
        processCellCallback: this.processCellCallback,
      };
      this.gridApi.exportDataAsExcel(params);
    }
  }

  fetchData() {
    this.setState({ loading: true, loaded: false });
    this.props.dispatch(fetchTVProductMappings())
      .then(
        ({ useProductMappings, requireProducts, allowMultipleProducts, allFields }) => {
          if (this.mounted) {
            this.setState({ 
              loading: false,
              loaded: true, 
              tvUseProductMappings: useProductMappings,
              tvRequireProducts: requireProducts,
              tvAllowMultipleProducts: allowMultipleProducts,
              allFields,
            });
            delay(() => {
              if (this.gridApi) {
                //this.gridApi.sizeColumnsToFit();
              }
            }, 500);
          }
        },
        () => {
          if (this.mounted) {
            this.setState({ loading: false, loaded: false });
          }
        },
      );
  }

  columnValueGetter(params) {
    if (!params) {
      return null;
    }
    const { data } = params;
    // if (data.type === 'product' || data.type === 'inline-product') {
    if (data && data.type === 'product') {      
      return data.is_active ? 'ACTIVE' : 'INACTIVE';
    }
    return 'ALL';
  }

  valueSetter(params) {
    const { data, newValue, colDef: { cellRendererParams: { program } } } = params;
    const submitParams = {
      client_id: program.client_id,
      program_id: program.program_id,
      use_product_mappings: true,
      mappings: [
        {
          ts_product_id: data.id,
          tv_product_id: newValue === 'null' ? null : newValue,
        },
      ],
    };
    this.props.dispatch(updateTVProductMappings(submitParams))
      .then(() => {
        if (this.gridApi) {
          this.gridApi.refreshCells({ force: true, columns: [`mappings.${program.client_id}.${program.program_id}`, 'ag-Grid-AutoColumn'] });
          this.gridApi.refreshClientSideRowModel('aggregate');
          const node = this.gridApi.getRowNode(data.id);
          if (node) {
            this.gridApi.flashCells({ rowNodes: [node] });
          }
        }
      });
    return true;
  }

  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }

  renderStatusDropdown() {
    const { selectedStatus } = this.state; 
    const options = [
      { id: 'ALL', label: 'All Products' },
      { id: 'ACTIVE', label: 'Active Products' },
      { id: 'INACTIVE', label: 'In-active Products' },
    ];
    const current = find(options, { id: selectedStatus }) || first(options);
    return (
      <div>
        <Dropdown
          id="prefilled-ranges"
        >
          <Dropdown.Toggle>
            <span>Showing: <strong>{current.label}</strong></span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {options.map((option) => {
              return (
                <MenuItem
                  key={option.id || 'default-value'}
                  active={option.id === selectedStatus}
                  onSelect={() => {
                    this.applyStatusFilter(option.id);
                  }}
                >
                  {option.label}
                </MenuItem>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  renderContent() {
    const {
      programs,
      products,
      refs,
      viewableDimensions: { height },
    } = this.props;
    const { selectedStatus } = this.state;
  
    const data = filter(products, (product) => {
      const validProduct = product.type !== 'tv-product';
      let validStatus = false;
      if (validProduct) {
        if (selectedStatus !== 'ALL') {
          /*
          validStatus = (
            ((product.type === 'inline-product' || product.type === 'product') && product.is_active === (selectedStatus === 'ACTIVE')) ||
            (product.type !== 'inline-product' && product.type !== 'product')
          );
          */
          validStatus = product.is_active === (selectedStatus === 'ACTIVE');
        } else {
          validStatus = true;
        }
      }
      return validProduct && validStatus;
    });

    const columnDefs = [
      {
        field: 'label',
        headerName: 'TruSales Product',
        headerComponent: LabelCellRenderer,
        pinned: 'left',
        suppressMenu: true,
        colId: 'LABEL',
        suppressMovable: true,
        width: 250,
        cellRendererSelector: this.columnCellRendererSelector,
        cellStyle: () => {
          return { paddingLeft: '30px' };
        },
      },
      {
        field: 'id',
        headerName: 'Product Id',
        hide: true,
      },
      /*
      {
        field: 'is_active',
        headerName: 'Active',
        colId: 'STATUS',
        hide: true,
        filter: true,
        valueGetter: this.columnValueGetter,
      },
      */
      ...(reduce(programs, (items, subPrograms, masterProgram) => {
        items.push({
          headerName: masterProgram,
          headerGroupComponent: ProgramCellRenderer,

          children: reduce(subPrograms, (sItems, subProgram) => {
            let refData = {};
            if (refs[subProgram.client_id] && refs[subProgram.client_id][subProgram.program_id]) {
              refData = refs[subProgram.client_id][subProgram.program_id];
            }
            refData = {
              ...refData,
              null: '[excluded]',
            };
            sItems.push({
              headerName: subProgram.name,
              field: `mappings.${subProgram.client_id}.${subProgram.program_id}`,
              cellRendererParams: {
                program: subProgram,
                refData,
              },
              refData,
              editable: true,
              cellEditor: 'agRichSelectCellEditor',
              cellEditorParams: {
                values: keys(refData),
                cellRenderer: (params) => {
                  // return `<div style="display:inline-block;width:450px;">${refData[params.value]}</div>`;
                  return refData[params.value] || '[Excluded]';
                },
              },
              valueSetter: this.valueSetter,
              cellRenderer: ProductCellRenderer,
              singleClickEdit: true,
              suppressMiniFilter: true,
              suppressSorting: true,
              suppressMenu: true,
            });
            return sItems;
          }, []),
        });
        return items;
      }, [])),
      {
        field: 'type',
        headerName: 'Type',
        rowGroup: true,
        rowGroupIndex: 0,
        hide: true,
      },
    ];
    console.log('data', data)
    return (
      <div>
        <nav className="navbar navbar-default navbar-controls">
          <div className="navbar-form navbar-left">
            <SearchField onSearch={this.handleSearch} />
          </div>
          <div className="navbar-form navbar-left">
            {this.renderStatusDropdown()}
          </div>
          {this.renderDownloadButton()}
        </nav>
        <div className={`ag-theme-alpine ${styles.table}`} style={{ height, width: '100%' }}>
          <AgGridReact
            reactNext
            enableColResize
            enableSorting
            enableFilter
            animateRows
            context={{
              allFields: this.state.allFields,
            }}
            columnDefs={columnDefs}
            onGridReady={this.onGridReady}
            rowData={data}
            defaultColDef={{
              resizable: true,
            }}
            groupUseEntireRow
            groupDisplayType="groupRows"
            groupRowRendererParams={{
              innerRenderer: GroupRowInnerRenderer,
            }}
            getRowId={(params) => params.data?.id}
          />
        </div>
      </div>
    );
  }

  renderInstruction() {
    return (
      <div className="well well-sm">
        <p>If your win loss or customer experience program will cover multiple products, make sure you have completed the <Link to="/setup/filters/product">Product setup</Link> for TruSales first, before completing this setup.</p>
        <p>Map the TruSales products to the TruVoice products for each win loss analysis and customer experience program integrated in TruSales.</p>
        <p>If your programs will cover same product(s) for all opportunities submitted to TruVoice for feedback, disable the &rdquo;Map Multiple Products&ldquo; setting and select the TruVoice Product(s) that will be used.</p>
      </div>
    );
  }

  renderUnifyToggle() {
    const { loading, tvUseProductMappings, togglling } = this.state;

    return (
      <FormGroup>
        <Toggle
          onClick={this.onToggleUnify}
          on={<span>Yes</span>}
          off={<span>No</span>}
          disabled={(loading || togglling)}
          size="xs"
          onstyle="success"
          offstyle="danger"
          active={tvUseProductMappings}
        />
      </FormGroup>
    );
  }

  renderRequiredToggle() {
    const { loading, tvRequireProducts, requireTogglling } = this.state;

    return (
      <FormGroup>
        <Toggle
          onClick={this.onToggleRequire}
          on={<span>Yes</span>}
          off={<span>No</span>}
          disabled={(loading || requireTogglling)}
          size="xs"
          onstyle="success"
          offstyle="danger"
          active={tvRequireProducts}
        />
      </FormGroup>
    );
  }

  renderUnifyProductMappings() {
    const { programs, products, refs } = this.props;
    const data = filter(products, (product) => {
      return product.type === 'tv-product';
    });
    return (
      <div>
        <UnifyMappingTable
          programs={programs}
          products={data}
          refs={refs}
        />
      </div>
    );
  }

  renderMultipleToggle() {
    const { loading, tvAllowMultipleProducts, allowMultipleProductsTogglling } = this.state;
    return (
      <FormGroup>
        <Toggle
          onClick={this.onToggleAllowMultiple}
          on={<span>Yes</span>}
          off={<span>No</span>}
          disabled={(loading || allowMultipleProductsTogglling)}
          size="xs"
          onstyle="success"
          offstyle="danger"
          active={tvAllowMultipleProducts}
        />
      </FormGroup>
    );
  }
  

  renderToggles() {
    const { tvRequireProducts, tvAllowMultipleProducts } = this.state;

    return (
      <table className="table">
        <tbody>
          <tr>
            <td width="80">{this.renderRequiredToggle()}</td>
            <td>
              <div>Require Product to Submit Opportunity</div>
              <div>
                <em>{tvRequireProducts ? 'Opportunities can not be submitted for feedback without a product selected.' : 'Opportunities can be submitted for feedback without a product selected. Contacts will be asked which product(s) they evaluated or considered.'}</em>
              </div>
            </td>
          </tr>

          <tr>
            <td width="80">{this.renderMultipleToggle()}</td>
            <td>
              <div>Allow Multiple Product Selection on Submission</div>
              <div>
                <em>{tvAllowMultipleProducts ? 'Feedback Request windows will allow selecting multiple products when submitting an opportunity for feedback.' : 'Feedback Request windows will restrict selection to a single primary product.'}</em>
              </div>
            </td>
          </tr>
          

          <tr>
            <td>{this.renderUnifyToggle()}</td>
            <td>Map Multiple Products</td>
          </tr>
        </tbody>
      </table>
    )
  }

  renderDownloadButton() {
    return (
      <div className="navbar-form navbar-right" style={{ paddingRight: 30 }}>
        <OverlayTrigger placement="top" overlay={<Tooltip id="custom-field-download-tip">Export as Excel File</Tooltip>}>
          <Button bsStyle="link" onClick={this.handleDownload}>
            <Fa name="download" />
          </Button>
        </OverlayTrigger>
      </div>
    );
  }

  render() {
    const { loading, loaded, tvUseProductMappings } = this.state;
    const isLoading = loading || !loaded;
    if (isLoading) {
      return (<ProgressBar />);
    }
    return (
      <div>
        {this.renderInstruction()}
        {this.renderToggles()}
        {tvUseProductMappings && this.renderContent()}
        {!tvUseProductMappings && this.renderUnifyProductMappings()}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    viewableDimensions: getViewableDimensions(state),
    products: getTVProductMappings(state),
    tvUseProductMappings: getTVUseProductMappings(state), // https://github.com/lumen-software/TruSales/issues/1527
    tvRequireProducts: getTVRequireProducts(state),
    refs: getTVProductRefs(state),
  };
}

MappingTable.propTypes = {
  dispatch: PropTypes.func.isRequired,
  programs: PropTypes.shape({}).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tvUseProductMappings: PropTypes.bool.isRequired,
  tvRequireProducts: PropTypes.bool.isRequired,
  refs: PropTypes.shape({}).isRequired,
  viewableDimensions: PropTypes.shape({
    height: PropTypes.number,
  }).isRequired,
};

export default connect(mapStateToProps)(MappingTable);
